import React from 'react';

function PoliciesPage() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
      <h1>Mentions Légales & Politiques Baltee</h1>
      
      {/* =========================
          1. Conditions Générales d'Utilisation
      ========================== */}
      <section>
        <h2>1. Conditions Générales d’Utilisation (CGU)</h2>
        <p><strong>Dernière mise à jour :</strong> [Date]</p>
        
        <h3>1.1 Objet</h3>
        <p>
          Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet de définir 
          les modalités d’accès et d’utilisation de l’application mobile <strong>Baltee</strong> 
          (ci-après “l’Application”), ainsi que les droits et obligations des utilisateurs 
          et de l’éditeur, Baltee.
        </p>
        
        <h3>1.2 Éditeur de l’Application</h3>
        <ul>
          <li><strong>Dénomination sociale :</strong> BALTEE SAS</li>
          <li><strong>Adresse du siège :</strong> PL du Granier 35135 Chantepie</li>
          <li><strong>Capital social :</strong> 10 000 €</li>
          <li><strong>Contact :</strong> sav@baltee.com</li>
        </ul>
        
        <h3>1.3 Acceptation des CGU</h3>
        <p>
          En téléchargeant, installant ou utilisant l’Application, l’utilisateur 
          reconnaît avoir lu, compris et accepté les présentes CGU. 
          Si l’utilisateur n’accepte pas tout ou partie de ces conditions, 
          il est invité à ne pas utiliser l’Application.
        </p>

        <h3>1.4 Accès à l’Application</h3>
        <p>
          L’Application Baltee est accessible gratuitement sur les boutiques d’applications 
          (Google Play, Apple App Store, etc.), sous réserve de disposer d’un accès à internet 
          et d’un appareil compatible. Les coûts d’accès (connexion internet, etc.) sont à la 
          charge de l’utilisateur.
        </p>

        <h3>1.5 Fonctionnalités principales</h3>
        <ul>
          <li>
            <strong>Suivi d’activité et de position :</strong> Permet la géolocalisation en 
            temps réel pour vous localiser en cas de besoin.
          </li>
          <li>
            <strong>Notifications et alertes de sécurité :</strong> Envoi d’alertes en temps 
            réel à vos contacts d’urgence.
          </li>
          <li>
            <strong>Historique d’utilisation :</strong> Possibilité de consulter les parcours 
            enregistrés et le statut de vos alertes.
          </li>
        </ul>

        <h3>1.6 Obligations de l’utilisateur</h3>
        <ul>
          <li>
            <strong>Respect des lois en vigueur :</strong> L’utilisateur s’engage à n’utiliser 
            l’Application que dans le respect de la loi, des règlements et des présentes CGU.
          </li>
          <li>
            <strong>Exactitude des informations :</strong> L’utilisateur doit fournir des informations 
            exactes, notamment lors de la création de son compte ou lors de la configuration des 
            contacts d’urgence.
          </li>
          <li>
            <strong>Sécurité des identifiants :</strong> L’utilisateur est responsable de la 
            confidentialité de ses identifiants et mot de passe. Toute connexion ou action réalisée 
            via son compte est réputée effectuée par l’utilisateur lui-même.
          </li>
        </ul>

        <h3>1.7 Limitation de responsabilité</h3>
        <p>
          Baltee met tout en œuvre pour fournir des informations et un service fiables, 
          mais ne garantit pas l’absence totale d’erreurs ou d’interruptions. Les données 
          fournies (localisation, alertes, etc.) sont à titre informatif ; Baltee n’est pas 
          responsable des conséquences liées à une mauvaise interprétation ou un usage 
          inapproprié de l’Application.
        </p>

        <h3>1.8 Propriété intellectuelle</h3>
        <p>
          Tous les éléments (textes, logos, images, icônes, sons, logiciels, etc.) présents 
          dans l’Application sont protégés par les lois en vigueur sur la propriété 
          intellectuelle et restent la propriété exclusive de Baltee ou de ses partenaires. 
          Toute reproduction, représentation, modification, publication ou adaptation 
          sans autorisation préalable est interdite.
        </p>

        <h3>1.9 Modification des CGU</h3>
        <p>
          Baltee se réserve le droit de modifier à tout moment et sans préavis les présentes 
          CGU afin de les adapter aux évolutions de l’Application ou de la législation. 
          Les nouvelles conditions s’appliqueront dès leur publication sur l’Application.
        </p>

        <h3>1.10 Loi applicable et juridiction compétente</h3>
        <p>
          Les présentes CGU sont soumises au droit français. En cas de litige, les tribunaux 
          compétents du ressort de Paris seront seuls compétents, sous réserve d’une attribution 
          de compétence spécifique résultant d’un texte de loi ou règlement particulier.
        </p>
      </section>

      {/* =========================
          2. Politique de Confidentialité
      ========================== */}
      <section style={{ marginTop: '2rem' }}>
        <h2>2. Politique de Confidentialité</h2>
        <p><strong>Dernière mise à jour :</strong> [Date]</p>
        
        <h3>2.1 Objet</h3>
        <p>
          La présente Politique de Confidentialité décrit les types de données personnelles 
          que nous recueillons auprès des utilisateurs de l’application <strong>Baltee</strong>, 
          la manière dont nous les utilisons et les mesures prises pour protéger ces données.
        </p>

        <h3>2.2 Responsable du traitement</h3>
        <ul>
          <li><strong>Identité :</strong> BALTEE SAS</li>
          <li><strong>Adresse :</strong> PL du Granier 35135 Chantepie</li>
          <li><strong>Contact :</strong> sav@baltee.com</li>
        </ul>

        <h3>2.3 Données collectées</h3>
        <ul>
          <li><strong>Informations de compte :</strong> Nom, prénom, adresse e-mail, numéro de téléphone.</li>
          <li><strong>Données de localisation :</strong> Position GPS pour permettre l’envoi d’alertes de sécurité.</li>
          <li><strong>Données d’usage :</strong> Historique de parcours, fréquence d’utilisation, logs d’erreur.</li>
          <li><strong>Contacts d’urgence :</strong> Numéros de téléphone et e-mails des personnes à prévenir en cas de problème.</li>
        </ul>

        <h3>2.4 Finalités du traitement</h3>
        <ul>
          <li>Fournir les fonctionnalités de l’Application (alertes, suivi, etc.).</li>
          <li>Gérer les comptes utilisateurs et l’authentification.</li>
          <li>Améliorer l’Application via l’analyse des données d’usage.</li>
          <li>Communication : vous envoyer des notifications ou des e-mails importants relatifs à l’Application.</li>
        </ul>

        <h3>2.5 Base légale</h3>
        <p>
          Les traitements reposent sur l’exécution du contrat (les présentes CGU) pour 
          la plupart des fonctionnalités, le consentement pour la collecte et l’utilisation 
          de certaines données (ex. localisation précise) et l’intérêt légitime pour les 
          analyses statistiques anonymisées.
        </p>

        <h3>2.6 Conservation des données</h3>
        <p>
          Les données sont conservées pour la durée strictement nécessaire aux finalités décrites. 
          Par exemple : données de compte (tant que le compte est actif), données de localisation 
          conservées pour [durée à définir], etc.
        </p>

        <h3>2.7 Partage des données</h3>
        <p>
          Les données personnelles ne sont jamais vendues à des tiers. Elles peuvent être 
          partagées avec des prestataires de services (hébergement, e-mailing) soumis à des 
          obligations de confidentialité, ou avec les autorités compétentes si la loi l’exige.
        </p>

        <h3>2.8 Sécurité des données</h3>
        <p>
          Nous mettons en œuvre des mesures de sécurité (chiffrement, contrôle d’accès, 
          protocoles sécurisés) pour protéger vos données contre l’accès, l’altération, 
          la divulgation ou la destruction non autorisés.
        </p>

        <h3>2.9 Droits des utilisateurs</h3>
        <p>
          Conformément à la législation applicable (RGPD, etc.), vous disposez des droits 
          suivants : d’accès, de rectification, d’effacement, d’opposition, de portabilité. 
          Pour exercer ces droits, contactez-nous à : <strong>sav@baltee.com</strong>.
        </p>

        <h3>2.10 Modifications de la Politique de Confidentialité</h3>
        <p>
          Nous pouvons modifier cette politique à tout moment. La version la plus récente 
          est accessible dans l’Application ou sur notre site web officiel. Nous vous invitons 
          à la consulter régulièrement.
        </p>
      </section>

      {/* =========================
          3. Mentions Légales
      ========================== */}
      <section style={{ marginTop: '2rem' }}>
        <h2>3. Mentions Légales</h2>
        <ul>
          <li><strong>Éditeur de l’Application :</strong> BALTEE SAS</li>
          <li><strong>Siège social :</strong> PL du Granier 35135 Chantepie</li>
          <li>
            <strong>Hébergeur :</strong> AWS, 
          </li>
          <li><strong>Contact :</strong> contact@baltee.com</li>
        </ul>

        <p>
          Pour toute question, remarque ou demande relative à ces politiques, 
          vous pouvez nous contacter à l’adresse e-mail <strong>sav@baltee.com</strong>.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <p>
          <em>
            Ces textes sont proposés à titre indicatif. Chaque pays (ou zone géographique) 
            dispose de législations spécifiques. Nous vous recommandons de faire relire et 
            valider ces politiques par un professionnel du droit.
          </em>
        </p>
      </section>
    </div>
  );
}

export default PoliciesPage;
